import { Box, Checkbox, Divider, FormControlLabel, Grid, Typography } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import theme from "../../theme";
import CommonButton from "../../common/components/CommonButton";
import { Add, Check, Circle } from "@mui/icons-material";
import CommonDialog from "../../common/components/CommonDialog";
import CommonFormField from "../../common/components/CommonFormField";
import CommonSelect from "../../common/components/CommonSelect";
import { Academics, AreaObject, EnrollmentStatus, EnrollmentStatusObj, ExamAttempts, removeEmptyFields, Semesters, StudentGrade, SubjectArea, SubjectAreaObj, Subjects, UserTypeId } from "../../common/const";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { createAcademic, createSubject, getAcademicInfo, getSubjectInfo, updateAcademic, updateSubject } from "../../api/academicApi";
import { academicSuccess, setLoading, signUpSuccess } from "../../features/authSlice";
import { showNotification } from "../../common/components/Notification/ToastifyNotification";
import LoadingSpinner from "../../common/components/LoadingSpinner";
import CommonGradeButton from "./CommonGradeButton";
import { updateStudent } from "../../api/authApi";

const BasicInformation = () => {
    const dispatch = useDispatch();
    const { loading, academic, user } = useSelector((state) => state.auth);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [filter, setFilter] = useState('ACADEMICS');
    const [defaultGrade, setDefaultGrade] = useState(user?.student_current_grade);
    const [markGrade, setMarkGrade] = useState(user?.student_current_grade);
    const [currentGrade, setCurrentGrade] = useState(user?.student_current_grade);
    const [formData, setFormData] = useState({
        academic: {
            schoolname: '',
            academic: '',
            startDate: '',
            endDate: '',
            subjectArea: SubjectArea[0].value,
            subject: '',
            enrollmentStatus: '',
            grade: '',
            GPA: '',
            subjectStartDate: '',
            subjectEndDate: '',
            SATSubject: Subjects[0].value,
            firstAttempt: ExamAttempts[0].value,
            examDate: '',
            bestScore: '',
            superScore: '',
            noOfAttempt: '',
            semester: Semesters?.["Semester 1"],
            semGrade: '',
            semGpa: ''
        }
    });
    const [errors, setErrors] = useState({});
    const [subjects, setSubjects] = useState([]);

    const validateField = (name, value, subjectArea, firstAttempt, semester) => {
        switch (name) {
            case 'schoolname':
                if (!value) return 'School Name is required';
                return '';
            case 'academic':
                if (!value) return 'Academic is required';
                return '';
            case 'subject':
                if ((subjectArea === SubjectArea[0].value || subjectArea === SubjectArea[1].value) && !value) return 'Subject is required';
                return '';
            case 'grade':
                if ((subjectArea === SubjectArea[0].value || subjectArea === SubjectArea[1].value) && !value) return 'Semester 1 Grade is required';
                return '';
            case 'semGrade':
                if ((subjectArea === SubjectArea[0].value || subjectArea === SubjectArea[1].value) && semester === Semesters?.["Semester 2"] && !value) return 'Semester 2 Grade is required';
                return '';
            case 'SATSubject':
                if (subjectArea === SubjectArea[2].value && !value) return 'Subject is required';
                return '';
            case 'firstAttempt':
                if (subjectArea === SubjectArea[2].value && !value) return 'Is it a First Attempt? is required';
                return '';
            case 'examDate':
                if (subjectArea === SubjectArea[2].value && !value) return 'Exam Date is required';
                return '';
            case 'superScore':
                if (subjectArea === SubjectArea[2].value && !value) return 'Super Score is required';
                return '';
            case 'bestScore':
                if (subjectArea === SubjectArea[2].value && firstAttempt === ExamAttempts[1].value && !value) return 'Best Score is required';
                return '';
            case 'noOfAttempt':
                if (subjectArea === SubjectArea[2].value && firstAttempt === ExamAttempts[1].value && !value) {
                    return 'Number Of Attempts is required'
                } else if (subjectArea === SubjectArea[2].value && firstAttempt === ExamAttempts[1].value && value > 11) {
                    return 'Number of attempts cannot exceed 11. Please try again later.'
                }
                return '';
            default:
                return '';
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            academic: {
                ...prev.academic,
                [name]: value,
            },
        }));

        // Clear error for the field being changed
        if (errors[name]) {
            const error = validateField(name, value, formData.academic.subjectArea, formData.academic.firstAttempt, formData?.academic?.semester);
            if (!error) {
                setErrors(prev => ({ ...prev, [name]: undefined }));
            } else {
                setErrors(prev => ({ ...prev, [name]: error }));
            }
        }
    };

    const validateForm = () => {
        const newErrors = {};
        const subjectArea = formData.academic.subjectArea;
        const firstAttempt = formData.academic.firstAttempt;

        if (subjectArea === SubjectArea[0].value || subjectArea === SubjectArea[1].value) {
            const fieldsToRemove = ['SATSubject', 'firstAttempt', 'examDate', 'bestScore', 'superScore', 'noOfAttempt'];
            fieldsToRemove.forEach(field => {
                if (formData.academic[field] !== undefined) {
                    delete formData.academic[field];
                }
            });

            // Only validate subject and grade for subjectArea 1
            ['subject', 'grade', 'semGrade'].forEach(key => {
                const error = validateField(key, formData.academic[key], subjectArea, firstAttempt, formData.academic.semester);
                if (error) newErrors[key] = error;
            });

        } else if (subjectArea === SubjectArea[2].value) {
            const fieldsToRemove = ['subject', 'grade', 'semGrade'];
            fieldsToRemove.forEach(field => {
                if (formData.academic[field] !== undefined) {
                    delete formData.academic[field];
                }
            });

            ['SATSubject', 'firstAttempt', 'examDate', 'superScore', 'bestScore', 'noOfAttempt'].forEach(key => {
                const error = validateField(key, formData.academic[key], subjectArea, firstAttempt, formData.academic.semester);
                if (error) newErrors[key] = error;
            });
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateMainForm = () => {
        const newErrors = {};
        Object.keys(formData.academic).forEach(key => {
            const error = validateField(key, formData.academic[key]);
            if (error) newErrors[key] = error;
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    }

    const handleSubmit = async () => {
        try {
            if (!validateMainForm()) return;
            dispatch(setLoading({
                loading: true
            }));
            const data = {
                "school_name": formData.academic.schoolname,
                "academic_status": formData.academic.academic,
                "start_date": formData.academic.startDate !== '' ? new Date(formData.academic.startDate).toISOString() : null,
                "end_date": formData.academic.endDate !== '' ? new Date(formData.academic.endDate).toISOString() : null,
                "student_grade": currentGrade,
                "student_id": user.student_id
            };
            if (markGrade !== null) {
                const result = await updateStudent(user?.student_id, {
                    student_current_grade: markGrade
                });
                dispatch(signUpSuccess({
                    user: {
                        ...user,
                        student_current_grade: result?.data?.student_current_grade,
                    }
                }));
            }
            if (academic === null) {
                const response = await createAcademic(removeEmptyFields(data));
                if (response.data.academic_id) {
                    dispatch(academicSuccess({
                        academic: response
                    }));
                    showNotification('Academic info added successfully', 'success');
                    dispatch(setLoading({
                        loading: false
                    }));
                }
            } else {
                const response = await updateAcademic(academic?.academic_id, removeEmptyFields(data));
                if (response.data.academic_id) {
                    dispatch(academicSuccess({
                        academic: response
                    }));
                    showNotification('Academic info updated successfully', 'success');
                    dispatch(setLoading({
                        loading: false
                    }));
                }
            }
            getAcademicData();
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            dispatch(setLoading({
                loading: false
            }));
            showNotification(errorMessage, 'error');
        }
    }

    const handleAcademicSubmit = async () => {
        try {
            if (!validateForm()) return;
            const data = {
                subject_name: formData.academic.subject || Subjects.find((a) => a.value === formData.academic.SATSubject).label,
                subject_area: SubjectAreaObj[formData.academic.subjectArea],
                enrollment_status: formData.academic.enrollmentStatus ? EnrollmentStatusObj[formData.academic.enrollmentStatus] : 'ENROLLED',
                super_score: formData.academic.superScore || 0,
                best_score: formData.academic.bestScore || 0,
                grade: formData.academic.grade,
                gpa: formData.academic.GPA,
                start_date: formData.academic.subjectStartDate && formData.academic.subjectStartDate !== '' ? new Date(formData.academic.subjectStartDate).toISOString() : null,
                end_date: formData.academic.subjectEndDate && formData.academic.subjectEndDate !== '' ? new Date(formData.academic.subjectEndDate).toISOString() : null,
                is_first_attempt: ExamAttempts.find((a) => a.value === formData.academic.firstAttempt)?.label === 'Yes',
                no_of_test_taken: formData.academic.noOfAttempt || 0,
                test_date: formData.academic.examDate && formData.academic.examDate !== '' ? new Date(formData.academic.examDate).toISOString() : null,
                is_active: true,
                academic_id: academic?.academic_id,
                student_id: user?.student_id,
                semester: formData?.academic?.semester,
                semester2_grade: formData?.academic?.semGrade,
                semester2_gpa: formData?.academic?.semGpa
            };
            let subjecResponse;
            dispatch(setLoading({
                loading: true
            }));
            if (formData.academic?.subject_id && formData.academic?.subject_id !== '') {
                subjecResponse = await updateSubject(formData.academic?.subject_id, data);
            } else {
                subjecResponse = await createSubject(data);
            }
            if (subjecResponse) {
                dispatch(setLoading({
                    loading: false
                }));
                if (formData.academic?.subject_id !== '') {
                    showNotification('Academic subject updated successfully', 'success');
                } else {
                    showNotification('Academic subject added successfully', 'success');
                }
                setDialogOpen(false);
                getSubjectData();
                setFormData((prev) => ({
                    ...prev,
                    academic: {
                        ...prev.academic,
                        subject_id: '',
                        subjectArea: SubjectArea[0].value,
                        subject: '',
                        enrollmentStatus: EnrollmentStatus[0].value,
                        grade: '',
                        GPA: '',
                        subjectStartDate: '',
                        subjectEndDate: '',
                        SATSubject: Subjects[0].value,
                        firstAttempt: ExamAttempts[0].value,
                        examDate: '',
                        bestScore: '',
                        superScore: '',
                        noOfAttempt: '',
                        semester: Semesters?.["Semester 1"],
                        semGrade: '',
                        semGpa: ''
                    },
                }));
            }
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            dispatch(setLoading({
                loading: false
            }));
            showNotification(errorMessage, 'error');
        }
    }

    const getAcademicData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const response = await getAcademicInfo(user.student_id, currentGrade);
            if (response?.data?.length > 0) {
                setFormData((prev) => ({
                    ...prev,
                    academic: {
                        ...prev.academic,
                        schoolname: response?.data?.[0]?.school_name || '',
                        academic: response?.data?.[0]?.academic_status || '',
                        startDate: response?.data?.[0]?.start_date ? moment(response?.data?.[0]?.start_date).format('YYYY-MM-DD') : '',
                        endDate: response?.data?.[0]?.end_date ? moment(response?.data?.[0]?.end_date)?.format('YYYY-MM-DD') : '',
                    },
                }));
                if (currentGrade === null) {
                    setCurrentGrade(response?.data?.[0]?.student_grade || StudentGrade[0].value);
                }
                dispatch(setLoading({
                    loading: false
                }));
                dispatch(academicSuccess({
                    academic: response?.data?.[0]
                }));
            } else {
                dispatch(setLoading({
                    loading: false
                }));
                setFormData((prev) => ({
                    ...prev,
                    academic: {
                        ...prev.academic,
                        schoolname: response?.data?.[0]?.school_name || '',
                        academic: response?.data?.[0]?.academic_status || '',
                        startDate: response?.data?.[0]?.start_date ? moment(response?.data?.[0]?.start_date).format('YYYY-MM-DD') : '',
                        endDate: response?.data?.[0]?.end_date ? moment(response?.data?.[0]?.end_date)?.format('YYYY-MM-DD') : '',
                    },
                }));
                if (currentGrade === null) {
                    setCurrentGrade(StudentGrade[0].value);
                }
                dispatch(academicSuccess({
                    academic: null
                }));
                setSubjects([]);
            }
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (user?.student_id) {
            getAcademicData();
        }
    }, [user?.student_id, currentGrade]);

    const getSubjectData = async () => {
        try {
            dispatch(setLoading({
                loading: true
            }));
            const subjectRes = await getSubjectInfo(academic?.academic_id);
            setSubjects(subjectRes.data.filter((a) => a.subject_area === filter));
            dispatch(setLoading({
                loading: false
            }));
        } catch (err) {
            const errorMessage = err.response?.data?.errors?.[0]?.message || err.response?.data?.message || err?.response?.data?.error;
            showNotification(errorMessage, 'error');
            dispatch(setLoading({
                loading: false
            }));
        }
    }

    useEffect(() => {
        if (academic?.academic_id) {
            getSubjectData();
        }
    }, [academic?.academic_id, filter]);

    const getMinDate = () => {
        const date = formData.academic.startDate ? new Date(formData.academic.startDate) : new Date();
        date.setDate(date.getDate() + 1); // Add 7 days
        console.log(date.toISOString().split('T')[0])
        return date.toISOString().split('T')[0];
    };

    const getMinEndDate = () => {
        const date = formData.academic.subjectStartDate ? new Date(formData.academic.subjectStartDate) : new Date();
        date.setDate(date.getDate() + 1); // Add 7 days
        return date.toISOString().split('T')[0];
    }

    return (
        <Fragment>
            {loading && (
                <LoadingSpinner />
            )}
            <CommonDialog
                open={dialogOpen}
                size="sm"
                title={
                    <Fragment>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                            <Typography sx={{ fontWeight: 600, fontSize: 18 }}>{formData?.academic?.subject_id && formData?.academic?.subject_id !== '' ? 'Edit Basic Academic Information' : 'Add Basic Academic Information'}</Typography>
                        </Box>
                        <Divider />
                    </Fragment>
                }
                content={
                    <Grid container spacing={1.5} mt={0.5} mb={2}>
                        <Grid item xs={12} md={12}>
                            <CommonSelect
                                label="Subject Area"
                                name="subjectArea"
                                value={formData.academic.subjectArea}
                                onChange={handleInputChange}
                                placeholder="Select Subject Area"
                                options={SubjectArea}
                            />
                        </Grid>
                        {(formData.academic.subjectArea === 1 || formData.academic.subjectArea === 2) && (
                            <>
                                <Grid item xs={12} md={6}>
                                    <CommonFormField
                                        label="Subject"
                                        type="email"
                                        name="subject"
                                        value={formData.academic.subject}
                                        onChange={handleInputChange}
                                        error={errors.subject}
                                        placeholder="e.g., Mathematics"
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CommonSelect
                                        label="Enrollment Status"
                                        name="enrollmentStatus"
                                        value={formData.academic.enrollmentStatus}
                                        onChange={handleInputChange}
                                        placeholder="Select Status"
                                        options={EnrollmentStatus}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <CommonSelect
                                        label="Semester"
                                        name="semester"
                                        value={formData.academic.semester}
                                        onChange={handleInputChange}
                                        placeholder="Select Semester"
                                        options={[{
                                            label: 'Semester 1', value: 'SEMESTER_1'
                                        },
                                        {
                                            label: 'Semester 2', value: 'SEMESTER_2'
                                        }]}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CommonFormField
                                        label="Semester 1 Grade"
                                        type="email"
                                        name="grade"
                                        value={formData.academic.grade}
                                        onChange={handleInputChange}
                                        error={errors.grade}
                                        placeholder="e.g., A, A+, 95%"
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CommonFormField
                                        label="Semester 1 GPA"
                                        type="number"
                                        name="GPA"
                                        value={formData.academic.GPA}
                                        onChange={handleInputChange}
                                        placeholder="Enter GPA"
                                    />
                                </Grid>
                                {formData.academic.semester === Semesters?.["Semester 2"] && (
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <CommonFormField
                                                label="Semester 2 Grade"
                                                type="email"
                                                name="semGrade"
                                                value={formData.academic.semGrade}
                                                onChange={handleInputChange}
                                                error={errors.semGrade}
                                                placeholder="e.g., A, A+, 95%"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <CommonFormField
                                                label="Semester 2 GPA"
                                                type="number"
                                                name="semGpa"
                                                value={formData.academic.semGpa}
                                                onChange={handleInputChange}
                                                placeholder="Enter GPA"
                                            />
                                        </Grid>
                                    </>
                                )}
                                <Grid item xs={12} md={6}>
                                    <CommonFormField
                                        label="Start Date"
                                        type="date"
                                        name="subjectStartDate"
                                        value={formData.academic.subjectStartDate}
                                        onChange={handleInputChange}
                                        placeholder="Select Start Date"
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CommonFormField
                                        label="End Date"
                                        type="date"
                                        name="subjectEndDate"
                                        value={formData.academic.subjectEndDate}
                                        onChange={handleInputChange}
                                        placeholder="Select End Date"
                                        minDate={getMinEndDate()}
                                    />
                                </Grid>
                            </>
                        )}
                        {formData.academic.subjectArea === 3 && (
                            <>
                                <Grid item xs={12} md={6}>
                                    <CommonSelect
                                        label="Select Subject"
                                        name="SATSubject"
                                        value={formData.academic.SATSubject}
                                        onChange={handleInputChange}
                                        placeholder="Select Subject"
                                        error={errors.SATSubject}
                                        options={Subjects}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CommonSelect
                                        label="Is it a First Attempt?"
                                        name="firstAttempt"
                                        value={formData.academic.firstAttempt}
                                        onChange={handleInputChange}
                                        error={errors.firstAttempt}
                                        options={ExamAttempts}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <CommonFormField
                                        label="Exam Date"
                                        type="date"
                                        name="examDate"
                                        value={formData.academic.examDate}
                                        onChange={handleInputChange}
                                        error={errors.examDate}
                                        placeholder="Select exam date"
                                    />
                                </Grid>
                                {formData.academic.firstAttempt === 2 && (
                                    <>
                                        <Grid item xs={12} md={6}>
                                            <CommonFormField
                                                label="Number Of Attempts"
                                                type="number"
                                                name="noOfAttempt"
                                                value={formData.academic.noOfAttempt}
                                                onChange={handleInputChange}
                                                error={errors.noOfAttempt}
                                                placeholder="Enter number of attempts"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <CommonFormField
                                                label="Best Score"
                                                type="number"
                                                name="bestScore"
                                                value={formData.academic.bestScore}
                                                onChange={handleInputChange}
                                                error={errors.bestScore}
                                                placeholder="Enter best ccore"
                                            />
                                        </Grid>
                                    </>
                                )}
                                <Grid item xs={12} md={6}>
                                    <CommonFormField
                                        label="Super Score"
                                        type="number"
                                        name="superScore"
                                        value={formData.academic.superScore}
                                        onChange={handleInputChange}
                                        error={errors.superScore}
                                        placeholder="Enter super ccore"
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Typography variant="body1" sx={{ fontSize: '14px', fontWeight: 400, color: 'text.main' }}>
                                        Please provide all details, it will helpful for our AI algorithm, to calculate your better
                                        score
                                    </Typography>
                                </Grid>
                            </>
                        )}
                    </Grid>
                }
                actionButtons={(
                    <Fragment>
                        <CommonButton
                            label="Cancel"
                            size="small"
                            background='white'
                            color={theme.palette.secondary.main}
                            border={`1px solid ${theme.palette.background.secondary}`}
                            fontWeight={700}
                            marginBottom="10px"
                            handleClick={async () => {
                                setFormData((prev) => ({
                                    ...prev,
                                    academic: {
                                        ...prev.academic,
                                        subject_id: '',
                                        subjectArea: SubjectArea[0].value,
                                        subject: '',
                                        enrollmentStatus: '',
                                        grade: '',
                                        GPA: '',
                                        subjectStartDate: '',
                                        subjectEndDate: '',
                                        SATSubject: Subjects[0].value,
                                        firstAttempt: ExamAttempts[0].value,
                                        examDate: '',
                                        bestScore: '',
                                        superScore: '',
                                        noOfAttempt: '',
                                        semester: Semesters?.["Semester 1"],
                                        semGrade: '',
                                        semGpa: ''
                                    },
                                }));
                                setErrors({});
                                setDialogOpen(false)
                            }}
                        />
                        <CommonButton
                            label={formData?.academic?.subject_id && formData?.academic?.subject_id !== '' ? 'Edit' : 'Add'}
                            size="small"
                            background={theme.palette.secondary.main}
                            color={theme.palette.background.main}
                            fontWeight={700}
                            marginBottom="10px"
                            handleClick={() => {
                                handleAcademicSubmit();
                            }}
                        />
                    </Fragment>
                )}
            />
            <CommonCard
                borderRadius={1}
                border={`1px solid ${theme.palette.background.secondary}`}
                paddingBottom="0px"
                padding="0px"
                marginTop="0px"
                headerContent={
                    <Box>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            p={2}
                        >
                            <Box>
                                <Typography fontSize={22} fontWeight={600}>My Basic Academic Information</Typography>
                                <Typography fontSize={15} color={theme.palette.background.dark}>Select the plan that best your goals and access level.</Typography>
                            </Box>
                            {user?.user_type_id === UserTypeId.Student && (
                                <Box
                                    display="flex"
                                    alignItems="center"
                                    gap={2}
                                >
                                    <CommonButton
                                        label="Add"
                                        width="130px"
                                        marginBottom="0px"
                                        fontWeight={600}
                                        startIcon={<Add />}
                                        handleClick={() => setDialogOpen(true)}
                                    />
                                </Box>
                            )}
                        </Box>
                        <Divider />
                    </Box>
                }
                content={
                    <Fragment>
                        <Grid container spacing={1} sx={{ padding: '13px', marginBottom: 1 }}>
                            <Grid item xs={12} md={12} display="flex" gap={1}>
                                <CommonGradeButton
                                    currentGrade={currentGrade}
                                    setCurrentGrade={setCurrentGrade}
                                    setDefaultGrade={setDefaultGrade}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CommonFormField
                                    label="School Name"
                                    type="email"
                                    name="schoolname"
                                    value={formData.academic.schoolname}
                                    onChange={handleInputChange}
                                    error={errors.schoolname}
                                    placeholder="Enter School Name"
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CommonSelect
                                    label="Academic"
                                    name="academic"
                                    value={formData.academic.academic}
                                    onChange={handleInputChange}
                                    placeholder="Select academic"
                                    error={errors.academic}
                                    options={Academics}
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CommonFormField
                                    label="Start Date"
                                    type="date"
                                    name="startDate"
                                    value={formData.academic.startDate}
                                    onChange={handleInputChange}
                                    placeholder="Select Start Date"
                                />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <CommonFormField
                                    label="End Date"
                                    type="date"
                                    name="endDate"
                                    value={formData.academic.endDate}
                                    onChange={handleInputChange}
                                    placeholder="Select End Date"
                                    minDate={getMinDate()}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name="rememberMe"
                                            checked={markGrade !== null ? defaultGrade === markGrade : false}
                                            onChange={() => setMarkGrade(defaultGrade)}
                                            color="secondary"
                                            size="small"
                                            icon={<Circle sx={{ fontSize: 20, color: theme.palette.background.light }} />}
                                            checkedIcon={
                                                <Box sx={{ background: theme.palette.secondary.main, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 0.3 }}>
                                                    <Check sx={{ color: 'white', fontSize: 12 }} />
                                                </Box>
                                            }
                                            sx={{
                                                padding: '4px',
                                                '& .MuiSvgIcon-root': {
                                                    borderRadius: '50%',
                                                },
                                            }}
                                        />
                                    }
                                    label={
                                        <Typography variant="body2" sx={{ fontSize: '14px' }}>
                                            Mark {defaultGrade || currentGrade} as a current grade
                                        </Typography>
                                    }
                                    sx={{ m: 0 }}
                                />
                            </Grid>
                        </Grid>
                        <Divider />
                        <Box
                            display="flex"
                            gap={1}
                            width="50%"
                            padding={2}
                        >
                            <CommonButton
                                label='Academics'
                                size="small"
                                height="35px"
                                marginBottom="0px"
                                fontWeight="bold"
                                width="20%"
                                background={filter === 'ACADEMICS' ? theme.palette.primary.main : theme.palette.background.main}
                                color={filter === 'ACADEMICS' ? theme.palette.secondary.main : theme.palette.background.dark}
                                handleClick={() => {
                                    setFilter('ACADEMICS');
                                }}
                                border={filter !== 'ACADEMICS' ? "1px solid lightgray" : 'none'}
                            />
                            <CommonButton
                                label='AP Exam'
                                size="small"
                                height="35px"
                                marginBottom="0px"
                                fontWeight="bold"
                                width="20%"
                                background={filter === 'AP_EXAM' ? theme.palette.primary.main : theme.palette.background.main}
                                color={filter === 'AP_EXAM' ? theme.palette.secondary.main : theme.palette.background.dark}
                                handleClick={() => {
                                    setFilter('AP_EXAM');
                                }}
                                border={filter !== 'AP_EXAM' ? "1px solid lightgray" : 'none'}
                            />
                            <CommonButton
                                label='SAT'
                                size="small"
                                height="35px"
                                marginBottom="0px"
                                fontWeight="bold"
                                width="25%"
                                background={filter === 'SAT_SCT' ? theme.palette.primary.main : theme.palette.background.main}
                                color={filter === 'SAT_SCT' ? theme.palette.secondary.main : theme.palette.background.dark}
                                handleClick={() => {
                                    setFilter('SAT_SCT');
                                }}
                                border={filter !== 'SAT_SCT' ? "1px solid lightgray" : 'none'}
                            />
                        </Box>
                        <Grid container spacing={1} sx={{ padding: '13px', marginBottom: 1 }}>
                            {subjects.length > 0 && subjects?.map((a, index) => (
                                <Grid item md={4}>
                                    <CommonCard
                                        key={index}
                                        borderRadius={1}
                                        border={`1px solid ${theme.palette.background.secondary}`}
                                        paddingBottom="0px"
                                        padding="13px"
                                        marginTop="0px"
                                        content={
                                            <Fragment>
                                                <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    alignItems="center"
                                                >
                                                    <Typography fontWeight={600}>{a.subject_name}</Typography>
                                                    <Box
                                                        display="flex"
                                                        gap={1}
                                                    >
                                                        {user?.user_type_id === UserTypeId.Student && (
                                                            <CommonButton
                                                                label="Edit"
                                                                background="white"
                                                                marginBottom="0px"
                                                                border={`1px solid ${theme.palette.background.secondary}`}
                                                                height="30px"
                                                                width="50px"
                                                                fontWeight={600}
                                                                handleClick={() => {
                                                                    setDialogOpen(true);
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        academic: {
                                                                            ...prev.academic,
                                                                            subject_id: a.subject_id,
                                                                            subjectArea: AreaObject[a.subject_area],
                                                                            subject: a.subject_name,
                                                                            enrollmentStatus: a.enrollment_status,
                                                                            grade: a.grade,
                                                                            GPA: a.gpa,
                                                                            subjectStartDate: a.start_date !== null ? moment(a.start_date)?.format('YYYY-MM-DD') : '',
                                                                            subjectEndDate: a.end_date !== null ? moment(a.end_date)?.format('YYYY-MM-DD') : '',
                                                                            SATSubject: a.subject_name ? Subjects.find((i) => i.label === a.subject_name)?.value : '',
                                                                            firstAttempt: a.is_first_attempt === true ? ExamAttempts[0]?.value : ExamAttempts[1]?.value,
                                                                            examDate: a.test_date,
                                                                            bestScore: a.best_score,
                                                                            superScore: a.super_score,
                                                                            noOfAttempt: a.no_of_test_taken,
                                                                            semester: a?.semester,
                                                                            semGrade: a?.semester2_grade,
                                                                            semGpa: a?.semester2_gpa
                                                                        },
                                                                    }));
                                                                }}
                                                            />
                                                        )}
                                                        <Box
                                                            border={`1px solid ${theme.palette.background.secondary}`}
                                                            borderRadius={0.6}
                                                            padding="3px 10px"
                                                            sx={{
                                                                background: a.enrollment_status === 'ENROLLED' ? theme.palette.secondary.main : a.enrollment_status === 'DROPPED' ? 'red' : '#01875F',
                                                            }}
                                                        >
                                                            <Typography fontSize={14} color={a.enrollment_status === 'ENROLLED' ? theme.palette.primary.main : a.enrollment_status === 'DROPPED' ? 'white' : 'white'}>{a.enrollment_status === 'ENROLLED' ? 'In Progress' : a.enrollment_status === 'COMPLETED' ? 'Pass' : 'Fail'}</Typography>
                                                        </Box>
                                                    </Box>
                                                </Box>
                                                <Box
                                                    display="flex"
                                                    gap={1}
                                                    mt={1}
                                                >
                                                    {filter !== 'SAT_SCT' ? (
                                                        <>
                                                            <Box
                                                                display="flex"
                                                                border={`1px solid ${theme.palette.background.secondary}`}
                                                                borderRadius={0.6}
                                                                padding="0px 5px"
                                                                flexDirection="column"
                                                            >
                                                                <Typography fontSize={13}>Sem 1 :</Typography>
                                                                <Typography fontSize={13} color={theme.palette.background.dark}>Grade: {a.grade} | GPA: {a.gpa}</Typography>
                                                            </Box>
                                                            {a.semester === Semesters["Semester 2"] && (
                                                                <Box
                                                                    display="flex"
                                                                    border={`1px solid ${theme.palette.background.secondary}`}
                                                                    borderRadius={0.6}
                                                                    padding="0px 5px"
                                                                    flexDirection="column"
                                                                >
                                                                    <Typography fontSize={13}>Sem 2 :</Typography>
                                                                    <Typography fontSize={13} color={theme.palette.background.dark}>Grade: {a.semester2_grade} | GPA: {a.semester2_gpa}</Typography>
                                                                </Box>
                                                            )}
                                                        </>
                                                    ) : (
                                                        <Box
                                                            display="flex"
                                                            gap={1}
                                                            border={`1px solid ${theme.palette.background.secondary}`}
                                                            borderRadius={0.6}
                                                            padding="0px 5px"
                                                        >
                                                            <Typography fontSize={14} color={theme.palette.background.dark}>First Attempt:</Typography>
                                                            <Typography fontSize={14}>{a.is_first_attempt ? 'Yes' : 'No'}</Typography>
                                                        </Box>
                                                    )}
                                                </Box>
                                                {filter !== 'SAT_SCT' ? (
                                                    <Box
                                                        display="flex"
                                                        gap={10}
                                                        mt={1}
                                                    >
                                                        <Box>
                                                            <Typography fontSize={14} fontWeight={600}>{a.start_date ? moment(a.start_date).format('DD MMM, YYYY') : '-'}</Typography>
                                                            <Typography fontSize={13} color={theme.palette.background.dark}>Start Date</Typography>
                                                        </Box>
                                                        <Box>
                                                            <Typography fontSize={14} fontWeight={600}>{a.end_date ? moment(a.end_date).format('DD MMM, YYYY') : '-'}</Typography>
                                                            <Typography fontSize={13} color={theme.palette.background.dark}>End Date</Typography>
                                                        </Box>
                                                    </Box>
                                                ) : <Box
                                                    display="flex"
                                                    gap={5}
                                                    mt={1}
                                                >
                                                    {!a.is_first_attempt && (
                                                        <Box>
                                                            <Typography fontSize={14} fontWeight={600}>{a?.no_of_test_taken}</Typography>
                                                            <Typography fontSize={13} color={theme.palette.background.dark}>Total Attempts</Typography>
                                                        </Box>
                                                    )}
                                                    <Box>
                                                        <Typography fontSize={14} fontWeight={600}>{a.test_date ? moment(a.test_date).format('DD MMM, YYYY') : '-'}</Typography>
                                                        <Typography fontSize={13} color={theme.palette.background.dark}>Exam Date</Typography>
                                                    </Box>
                                                    {!a.is_first_attempt && (
                                                        <Box>
                                                            <Typography fontSize={14} fontWeight={600}>{a.best_score}</Typography>
                                                            <Typography fontSize={13} color={theme.palette.background.dark}>Score</Typography>
                                                        </Box>)}
                                                </Box>}
                                            </Fragment>
                                        }
                                    />
                                </Grid>
                            ))}
                        </Grid>
                        <Divider />
                    </Fragment>
                }
                footerContent={
                    user?.user_type_id === UserTypeId.Student && (
                        <Box
                            display="flex"
                            justifyContent="flex-end"
                            width="100%"
                            paddingRight="5px"
                        >
                            <CommonButton
                                label="Save Changes"
                                handleClick={handleSubmit}
                                marginBottom="10px"
                                marginTop="10px"
                                fontWeight={600}
                                width='14%'
                            />
                        </Box>)
                }
            />
        </Fragment>
    )
}

export default BasicInformation;